import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createRendererMotionComponent } from '../../motion/index.mjs';
import { isSVGComponent } from '../dom/utils/is-svg-component.mjs';
import { svgMotionConfig } from '../svg/config-motion.mjs';
import { htmlMotionConfig } from '../html/config-motion.mjs';
import { createUseRender } from '../dom/use-render.mjs';
function createMotionComponentFactory(preloadedFeatures, createVisualElement) {
  return function createMotionComponent(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        forwardMotionProps: false
      },
      forwardMotionProps = _ref.forwardMotionProps;
    var baseConfig = isSVGComponent(Component) ? svgMotionConfig : htmlMotionConfig;
    var config = _objectSpread(_objectSpread({}, baseConfig), {}, {
      preloadedFeatures: preloadedFeatures,
      useRender: createUseRender(forwardMotionProps),
      createVisualElement: createVisualElement,
      Component: Component
    });
    return createRendererMotionComponent(config);
  };
}
export { createMotionComponentFactory };